export const TRANSFER_REASON_OTHER = 'OTHER';

export const TRANSFER_REASONS = [
  { value: 'Stock Replenishment', label: 'Stock Replenishment' },
  { value: 'Store Requirement', label: 'Store Requirement' },
  { value: 'Emergency Transfer', label: 'Emergency Transfer' },
  { value: 'Stock Balancing', label: 'Stock Balancing' },
  { value: TRANSFER_REASON_OTHER, label: 'Other' },
];

/**
 * The backend has no reason column — it stores whatever string we send in
 * transaction_payload.transfer_reason. "Other" is a UI affordance only, so it is
 * resolved to the typed text before the payload is built.
 */
export function resolveTransferReason(reason, customReason) {
  if (reason === TRANSFER_REASON_OTHER) return (customReason || '').trim();
  return reason || '';
}

/**
 * Transfers post stock in a single request, so the transaction is COMPLETED the
 * moment it is created — there is no dispatch/receive handoff to track. The
 * timeline states that plainly rather than implying steps that never happen.
 */
export const TRANSFER_TIMELINE_STEPS = [
  'Created',
  'Stock Deducted',
  'Stock Received',
];

export const TRANSFER_STATUSES = ['COMPLETED', 'REVERSED', 'CANCELLED'];
